import type { ReactiveControllerHost } from 'lit';
import { CustomError } from '../../../../_ui-core_/base/package/patterns/package/CError';
import App from '../../../../app';
import BaseController, { type EventAction, type IGameController } from '../base-controller';

type SpinomenalEvent = {
  eventName?: string;
  type?: string;
  sender?: string;
  lang?: string;
  data?: {
    totalBet?: number;
    type?: string;
    message?: string;
    code?: number;
    Id?: number;
    win?: number;
    isRoundFinish?: boolean;
    balanceAfter?: number;
    reason?: string;
  };
};

export default class SpinomenalGameController extends BaseController implements IGameController {
  constructor(host: ReactiveControllerHost) {
    super(host, 'spn');
  }

  public async getLaunchUrl(forReal: boolean, gameId: string): Promise<string> {
    try {
      const info = await App.instance.casino.getGameLaunchInfo(this.provider, gameId, forReal);

      if (!info.launchConfig.launchUrl) {
        return Promise.reject(new CustomError('Launch URL is missing.', { code: 404 }));
      }

      return info.launchConfig.launchUrl;
    } catch (error: any) {
      return Promise.reject(
        new CustomError(`Failed to get game launch info: ${error.message}`, {
          code: error.code || 500,
          type: error.type,
        }),
      );
    }
  }

  public getLaunchUrlIOs(forReal: boolean, gameId: string, gameBaseUrl: string): Promise<string> {
    window.$app.logger.warn('TODO - NATIVE GAME LAUNCH NOT IMPLEMENTED!', gameBaseUrl);
    return this.getLaunchUrl(forReal, gameId);
  }

  public handleMessageEvent(data: string | object): EventAction | null {
    window.$app.logger.log('message', data);

    const event = data as SpinomenalEvent;
    const eventName = event.eventName || event.type;

    if (!eventName) {
      return null;
    }

    switch (eventName) {
      case 'gameLoadingStart':
        return this.markActivity();
      case 'gameLoadingEnd':
        return this.markActivity();
      case 'gameLoadingError':
        return { action: 'error', error: event.data?.message || 'gameLoadingError' };

      case 'linkRedirect':
        return this.closeGame();

      case 'betPlaced':
        return this.markActivity();
      case 'betError':
        return { action: 'error', error: event.data?.message || 'betError' };
      case 'betFinished':
        return this.markActivityAndSpinSuccess();
    }

    return null;
  }

  public handleAdditionalEventListeners(_iframeUrl: string, _iframeEl: HTMLIFrameElement) {
    return;
  }
}
